import { authenticate } from '@kiper/fns';
import * as manager from './eventTriggerSetting.manager';

export const eventTriggerSettingCreate = authenticate(({ args, context }) =>
  manager.create({ input: args.input, ...context }),
);

export const eventTriggerSettingUpdate = authenticate(({ args, context }) =>
  manager.update({ id: args.id, input: args.input, ...context }),
);

export const eventTriggerSettingDelete = authenticate(({ args, context }) =>
  manager.remove({ id: args.id, ...context }),
);
